.activityName {
  white-space: normal;
  text-align: left;
  max-width: 300px;
}
